import LayerTip from '@/components/LayerTip';

import Vue from 'vue'
const components = [
    
]

const install = function(Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });

    Vue.prototype.$LayerTip = LayerTip.install
};

// if (typeof window !== 'undefined' && window.Vue) {
//     install(window.Vue);
// }
install(Vue);


// WEBPACK FOOTER //
// ./src/components/index.js